import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { OptionsListMulti } from 'gung-common';

@Component({
  selector: 'lib-template-alias-select',
  templateUrl: './template-alias-select.component.html',
  styleUrls: ['./template-alias-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TemplateAliasSelectComponent {
  @Input() optionsLoader!: () => OptionsListMulti[];
  @Input() selectedLabel?: string;
  @Output() selectedValue = new EventEmitter<string>();

  searchString = '';
  optionsList: OptionsListMulti[] = [];
  filteredOptions: OptionsListMulti[] = [];
  isOpen = false;

  get displayLabel(): string {
    if (this.optionsList.length > 0) {
      return this.optionsList.find(o => o.selected)?.id ?? '';
    }
    return this.selectedLabel ?? '';
  }

  onOpenChange(open: boolean): void {
    this.isOpen = open;
    if (open && this.optionsList.length === 0) {
      this.optionsList = this.optionsLoader();
      this.filteredOptions = this.optionsList;
    }
    if (!open) {
      this.searchString = '';
      this.filteredOptions = this.optionsList;
    }
  }

  setSearch(search: string): void {
    this.searchString = search;
    if (!search || search.trim() === '') {
      this.filteredOptions = this.optionsList;
      return;
    }
    const term = search.toUpperCase();
    this.filteredOptions = this.optionsList.filter(
      o => o.id?.toUpperCase().includes(term) || (o as any).badgeText?.toUpperCase().includes(term)
    );
  }

  select(option: OptionsListMulti): void {
    this.optionsList.forEach(o => (o.selected = o.id === option.id));
    this.isOpen = false;
    this.searchString = '';
    this.filteredOptions = this.optionsList;
    this.selectedValue.emit(option.id);
  }
}
